import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { ProductListItemDto } from './ProductListItemDto'
import { ShowcaseProductCollectionSeoDto } from './ShowcaseProductCollectionSeoDto'
/**
* Class ShowcaseProductCollectionDto
*  Полная страница подборки: мета, SEO и видимый состав
*/
export class ShowcaseProductCollectionDto extends ActiveModel {

  /**
  * id
  * Идентификатор подборки  */
  @ActiveField(0)
  id: number = 0


/**
  * slug
  * Глобальный ЧПУ; уникален среди неудалённых. Пустой при записи нормализуется из Name.<br>
  */
  @ActiveField('')
  slug: string = ''


/**
  * name
  * Название подборки.<br>
  */
  @ActiveField('')
  name: string = ''


/**
  * description
  * Описание (опционально).<br>
  */
  @ActiveField()
  description?: null | string


  /**
  * order
  * Порядковый номер среди подборок (глобальный).<br>  */
  @ActiveField(0)
  order: number = 0


/**
  * imagesIds
  * Идентификаторы изображений галереи в порядке Domain.Entities.ProductCollections.ProductCollectionImage.Order.<br>Первое — обложка.<br>  */
  @ActiveField({
    setter(model: ShowcaseProductCollectionDto, prop: string, value: Array<string>, receiver?: ShowcaseProductCollectionDto ) {
      return Reflect.set(
        model,
        prop,
        value ? (Array.isArray(value) ? value : [value])
          .map(v => String(v)) : value,
        
        receiver)
    }
  })
  imagesIds: Array<string> = []


/**
  * @property items
  * Видимые карточки товаров (после разрешения состава подборки)<br>  */
  @ActiveField({
    factory: [ProductListItemDto, () => []]
  })
  items: Array<ProductListItemDto> = []


  /**
  * seo
  * SEO-атрибуты страницы подборки.<br>  */
  @ActiveField({
    factory: [ShowcaseProductCollectionSeoDto, () => ShowcaseProductCollectionSeoDto.create()]
  })
  seo: ShowcaseProductCollectionSeoDto = ShowcaseProductCollectionSeoDto.create()


  /**
  * hasMoreItems
  * У Rule-подборки на детали показаны не все карточки — полный состав через каталог с `Filter.CollectionId`  */
  @ActiveField()
  hasMoreItems?: boolean
}
